<template>
  <div class="forgot-password-container">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <form v-if="!sentResetRequest" @submit.prevent="requestPasswordReset">
            <div class="form-group">
              <img :src="`${publicPath}covidLogo.png`" class="mx-auto d-block mt-5" alt="COVID Learners Logo" />
            </div>
            <div class="form-group mt-5">
              <label for="email" class="text-uppercase">{{ $t('login.email') }}</label>
              <input id="email" type="email" class="form-control" placeholder="sample@address.com" required v-model="params.data.attributes.email">
            </div>

            <div class="form-group">
              <button type="submit" class="btn btn-primary btn-block text-uppercase">{{ $t('login.forgotPasswordSendEmail') }}</button>
            </div>

            <div class="form-group">
              <p class="text-right text-uppercase"><router-link :to="{ name: 'Login' }">{{ $t('login.login') }}</router-link></p>
              <img :src="`${publicPath}alterisGroupLogo.png`" alt="AlterisGroup Logo" class="float-right mx-auto pt-5" />
            </div>
          </form>

          <div v-else>
            <div class="form-group">
              <img :src="`${publicPath}covidLogo.png`" class="mx-auto d-block" alt="COVID Learners Logo" />
            </div>

            <div class="form-group">
              <div class="card">
                <div class="card-body">
                  <p>{{ $t('login.forgotPasswordReturnMessage', { email: this.params.data.attributes.email }) }}</p>
                  <p>{{ $t('login.forgotPasswordReturnMessageBody') }}</p>
                </div>
              </div>
            </div>

            <div class="form-group">
              <router-link class="btn btn-primary btn-block text-uppercase" :to="{ name: 'Login' }">{{ $t('login.forgotPasswordReturnLogin') }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createApi } from '@/services/api.service';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      publicPath: process.env.BASE_URL,
      sentResetRequest: false,
      params: {
        data: {
          attributes: {
            email: null,
          },
        },
      },
    };
  },
  methods: {
    requestPasswordReset() {
      createApi('users/recover', this.params)
        .then(() => {
          // store token, set headers and push router to new dashboard page.
          this.sentResetRequest = true;
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.$notify({
              text: err.response.data.error,
              type: 'error',
            });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">
</style>
